/**
 * @file components/shared/SourceBadge.jsx
 * @description Visual indicator for the data origin (AI models vs Local storage).
 */

const SOURCE_META = {
  // Using a slightly higher opacity for the backgrounds to make them pop
  // against the new deep charcoal #0B0B0B background.
  gemini: {
    label: "Gemini 3 Flash",
    color: "text-blue-400",
    border: "border-blue-400/20",
    bg: "bg-blue-400/10",
    icon: "✦",
  },
  cerebras: {
    label: "Cerebras Llama",
    color: "text-purple-400",
    border: "border-purple-400/20",
    bg: "bg-purple-400/10",
    icon: "⬡",
  },
  // Updated Local to use 'brand-green' hints to reward the user for using local data.
  local: {
    label: "Local Database",
    color: "text-brand-green",
    border: "border-brand-green/20",
    bg: "bg-brand-green/5",
    icon: "◈",
  },
};

function getSource(result) {
  if (result?.source === "gemini") return "gemini";
  if (result?.source === "cerebras") return "cerebras";
  return "local";
}

export function SourceBadge({ result }) {
  const key = getSource(result);
  const meta = SOURCE_META[key];

  return (
    <div
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-lg border font-sans
                     text-[8px] font-bold uppercase tracking-[0.15em] whitespace-nowrap
                     transition-colors duration-300
                     ${meta.color} ${meta.border} ${meta.bg}`}
    >
      <span className="text-[10px] leading-none">{meta.icon}</span>
      <span>{meta.label}</span>

      {key === "local" && (
        <span className="ml-1 opacity-40 normal-case tracking-tight font-medium hidden sm:inline">
          — cached
        </span>
      )}
    </div>
  );
}
